import { Input, Label } from '@startupquickstart/frontend';
import { ImageUrlList } from './ImageUrlList';
import type { MinigameAuthoringPanelProps } from './types';

interface SlotMachineConfig {
  reelImages?: string[];
  reelCount?: number;
  winCondition?: number;
  pointsOnWin?: number;
  pointsOnLoss?: number;
}

const DEFAULTS: Required<SlotMachineConfig> = {
  reelImages: [],
  reelCount: 5,
  winCondition: 4,
  pointsOnWin: 100,
  pointsOnLoss: 0,
};

export function SlotMachinePanel({
  value,
  onChange,
  disabled,
}: MinigameAuthoringPanelProps<SlotMachineConfig>) {
  const v = { ...DEFAULTS, ...(value ?? {}) };

  const set = (patch: Partial<SlotMachineConfig>) => onChange({ ...v, ...patch });

  return (
    <div className="space-y-4 rounded-lg border bg-muted/30 p-4">
      <div className="space-y-1">
        <h4 className="text-sm font-semibold">Slot machine</h4>
        <p className="text-xs text-muted-foreground">
          Players spin reels of images. Match {v.winCondition} of {v.reelCount}{' '}
          to win.
        </p>
      </div>

      <ImageUrlList
        label="Reel images"
        helpText="Each spin samples from this image bank. 2–20 images."
        values={v.reelImages}
        onChange={(reelImages) => set({ reelImages })}
        disabled={disabled}
        min={2}
        max={20}
      />

      <div className="grid grid-cols-2 gap-3">
        <div className="space-y-1">
          <Label>Reel count</Label>
          <Input
            type="number"
            min={2}
            max={10}
            value={v.reelCount}
            disabled={disabled}
            onChange={(e) => set({ reelCount: Number(e.target.value) })}
          />
        </div>
        <div className="space-y-1">
          <Label>Win condition (matching reels)</Label>
          <Input
            type="number"
            min={2}
            max={v.reelCount}
            value={v.winCondition}
            disabled={disabled}
            onChange={(e) => set({ winCondition: Number(e.target.value) })}
          />
        </div>
        <div className="space-y-1">
          <Label>Points on win</Label>
          <Input
            type="number"
            min={0}
            value={v.pointsOnWin}
            disabled={disabled}
            onChange={(e) => set({ pointsOnWin: Number(e.target.value) })}
          />
        </div>
        <div className="space-y-1">
          <Label>Points on loss</Label>
          <Input
            type="number"
            value={v.pointsOnLoss}
            disabled={disabled}
            onChange={(e) => set({ pointsOnLoss: Number(e.target.value) })}
          />
        </div>
      </div>
    </div>
  );
}
